import { render, staticRenderFns } from "./DatasetView.vue?vue&type=template&id=8d2bfc6e&"
import script from "./DatasetView.vue?vue&type=script&lang=js&"
export * from "./DatasetView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d2bfc6e')) {
      api.createRecord('8d2bfc6e', component.options)
    } else {
      api.reload('8d2bfc6e', component.options)
    }
    module.hot.accept("./DatasetView.vue?vue&type=template&id=8d2bfc6e&", function () {
      api.rerender('8d2bfc6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DatasetView.vue"
export default component.exports